<template>
  <BCol md="2">
    <BRow class="timestamp-list-area d-flex flex-column justify-content-between">
        <div>
          <h5>Timestamps</h5>
          <div
              v-for="timestamp in getSync"
              :key="timestamp.id"
          >
            {{timestamp.start}}
            -
            {{timestamp.finish}}
          </div>
        </div>
    </BRow>
    <BRow class="mb-3">
      <button @click="downloadJson" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px">
      <i class="mdi mdi-check-circle"></i> Download JSON
    </button>
    </BRow>
    <BRow>
      <button @click="toAddSync" class="btn btn-success btn-lg m-l-20" type="submit" style="font-size: 15px">
      <i class="mdi mdi-check-circle"></i> Зберегти
    </button>
    </BRow>
  </BCol>
</template>

<script>
import * as chapterActions from "../../../../store/modules/Chapter/types/actions";
import { mapActions } from "vuex";
import { saveAs } from 'file-saver';
import { eventBus } from "../../../../app";

export default {
  name: "TimestampList",
  props: {
    currentChapter: Object
  },
  data() {
    return {
      canBeSaved: false
    };
  },
  computed: {
    getSync() {
      return this.currentChapter ? this.currentChapter.sync : null;
    }
  },
  methods: {
    ...mapActions('Chapter', {
      addSyncForCurrentChapter: chapterActions.ADD_SYNC_FOR_CURRENT_CHAPTER
    }),
    setNotification(variant, message) {
      Swal.fire(
          message,
          '',
          variant
      )
    },
    downloadJson() {
      const data = {
        [this.currentChapter.id]: {
          index: this.currentChapter.index,
          audioBookId: this.currentChapter.audioBookId,
          name: this.currentChapter.name,
          fullName: this.currentChapter.fullName,
          link: this.currentChapter.link,
          text: this.currentChapter.sentences
              ? _.reduce(this.currentChapter.sentences,
                  (prev, sentence) => ({
                    ...prev,
                    [sentence.id]: sentence.sentence
                  }),
                  {})
              : null,
          sync: this.currentChapter.sync
              ? _.reduce(this.currentChapter.sync,
                  (prev, sync) => ({
                    ...prev,
                    [sync.id]: {
                      start: sync.start,
                      finish: sync.finish
                    }
                  }),
                  {})
              : null,
        }
      }
      console.log(data)
      let blob  =  new Blob ([JSON.stringify(data)], { type : "text" } );
        saveAs (blob ,  "config.json" ) ;
      },
    async toAddSync() {
      try {
          await this.addSyncForCurrentChapter({
            id: this.currentChapter.id,
            timestamps: this.currentChapter.sync
          })
        if (this.canBeSaved) {
          this.setNotification('success', 'Маркери збережені')
        } else {
           this.setNotification('error', 'Не усi маркери проставленi')
        }
      } catch (err) {
        console.log(err)
      }

    }
  },
  created() {
    eventBus.$on('isAllParagraphChecked',
      isChecked => {
        this.canBeSaved = isChecked
      }
    )
  }
}
</script>

<style scoped>
.timestamp-list-area {
  overflow-y: auto;
  height: 40vh;
}
</style>